import $ from 'jquery'
import 'slick-carousel'
import './slider'
import './modal'
import './form.js'
import './scroll-reveal'
window.$ = window.jQuery = $
